
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { Field } from 'redux-form';

class Company extends Component {
    constructor(props) {
        super(props);
        }; 
        renderInput = ({ input, meta, label, style, maxLength, mask }) => {
            const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
            return (
                <InputMask {...input} autoComplete="new-password" className={className} placeholder={label} style={style} 
                // maxLength={maxLength}
                mask={mask}
                />
            );
        }
    render() {
        return (
            <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="form-group col-6">
                            <Field name="companyname" component={this.renderInput} maxLength={75} label="Name"   />		
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <Field name="address" component={this.renderInput} maxLength={75} label="Address"   />	
                            <Field name="city" component={this.renderInput} maxLength={75} label="City"   />	
                            <Field name="zip" component={this.renderInput} maxLength={75} label="Zip"   />	
                        </div>
                        <div className="form-group col-6">
                            <Field name="state" component={this.renderInput} maxLength={75} label="State"   />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Company;